exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#themecolors a{\r\n    cursor:pointer;\r\n}\r\n.c-secondary{\r\n    color: #06d79c !important;\r\n}\r\n.c-white{\r\n    color:white !important;\r\n}\r\n.pointer{\r\n    cursor:pointer;\r\n}\r\n.w-150{\r\n    width: 150px;\r\n}\r\n.mt-10{\r\n    margin-top:10px;\r\n}\r\n.w-50px{\r\n    width: 50px;\r\n}\r\n.w-70px{\r\n    width: 70px;\r\n}\r\n.background-black{\r\n    background-color:rgba(0,0,0,0.4);\r\n    position:fixed;\r\n    top:0px;\r\n    left:0px;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n}\r\n\r\n.hidden{\r\n    display: none\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/xampp/htdocs/Documentos/Angular/14-AdminPro/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles